import React from "react";
const list = React.lazy(() => import("./pages/list"));
const management = React.lazy(() => import("./pages/management"));
const Detail = React.lazy(() => import("./pages/details"));

const routes = [
  {
    name: "Devoluciones Vencidos",
    path: "/due-return",
    component: list,
    exact: true
  },
  {
    name: "Captura de Devolución Vencidos",
    path: "/due-return/new/:count",
    component: management,
    exact: true
  },
  {
    name: "Detalle de Devolución Vencidos",
    path: "/due-return/detail/:id",
    component: Detail,
    exact: true
  }
];

export default routes;
